<template>
  <div :class="this.$route.name" v-if="content">
    <!-- <sticky-nav :active="activeId" :sections="sections" /> -->

    <!-- HERO -->
    <div class="hero" v-if="$route.name === 'Home' && heroQuote">
      <section-quote :item="heroQuote" />
    </div>

    <div class="hero" v-else>
      <g-map :title="heroTitle" :text="heroText" :key="$route.fullPath" />
    </div>

    <section-resolver @intersected="onIntersected" :key="section.id" :section="section" v-for="section in sections" />

    <section-slider v-if="this.$route.name === 'Home'" />

    <section-contact v-if="$config" />
  </div>
</template>

<script>
import StickyNav from '@/components/sticky-nav'
import sectionQuote from '@sections/quote'
import sectionSlider from '@sections/slider'
import sectionContact from '@sections/contact'
import Quote from '@/models/sections/quote'
import SectionResolver from '@/library/section-resolver'
import FrontpageModel from '@/models/frontpage'
import gMap from '@/sections/map'

export default {
  inject: ['$config'],
  components: { StickyNav, SectionResolver, sectionQuote, sectionSlider, sectionContact, gMap },
  data: () => ({
    content: undefined,
    activeId: null
  }),
  async mounted () {
    await this.$nextTick()
  },
  async beforeRouteEnter (to, from, next) {
    let method = to.name === 'Subpage' ? 'byUri' : 'get'
    let content = await FrontpageModel[method](to.path)
    next(vm => {
      vm.$set(vm.$data, 'content', content)
      vm.$set(vm.$data, 'activeId', vm.sections.length > -1 ? vm.sections[0].id : null)
    })
  },
  methods: {
    onIntersected (id) {
      this.activeId = id
    }
  },
  computed: {
    heroQuote () {
      return this.content && this.content.item.properties.hero ? new Quote(this.content.item.properties.hero) : undefined
    },

    heroTitle () {
      return this.content && this.content.item.properties.heroTitle ? this.content.item.properties.heroTitle : null
    },

    heroText () {
      return this.content && this.content.item.properties.heroTekst ? this.content.item.properties.heroTekst : null
    },

    sections () {
      if (!this.content) {
        return []
      }

      return this.content.sections
    }
  }
}
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

.hero {
  margin-bottom: calc(#{$global-padding} * 3);

  min-height: 700px;

  @media #{$above-breakpoint-768} {
    margin-bottom: calc(#{$global-padding} * 7);
    max-height: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue